import { ArrowLeft, ArrowUpRight, ChevronRight, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { COOKIE_POLICY, LEGAL_INDEX } from "@aventuria/client-core/legal";
import { KUSPIT_LEGAL_NOTICE, KUSPIT_WALLET_NOTICE, PESO_A_PESO_NOTICE, TRAVEL_AGENCY_NOTICE } from "@aventuria/client-core/disclosures";
import { LegalDocumentPage } from "../components/LegalDocumentView";
import { Logo } from "../components/Logo";
import { WEBSITE_URL } from "../lib/website";

/**
 * "Información legal" (Perfil → Legal, client review 22 Oct 2026): the terms, the privacy notice,
 * the cookie policy and the travel conditions, then the providers' notices in full. Public, like
 * the documents it lists.
 */
export function LegalCenterPage() {
  return (
    <div className="legal-page">
      <header className="legal-head">
        <Link to="/inicio" className="legal-brand" aria-label="Ir a Inicio"><Logo height={26} /></Link>
        <Link to="/perfil" className="link-button"><ArrowLeft size={15} aria-hidden="true" /> Volver a Perfil</Link>
      </header>
      <main className="legal-body">
        <span className="page-eyebrow">Legal</span>
        <h1>Información legal</h1>
        <p className="legal-meta">Los documentos que rigen tu uso de Aventuria y los avisos de quienes prestan los servicios financieros.</p>

        <ul className="legal-index">
          {LEGAL_INDEX.map((entry) => {
            const body = (
              <>
                <span className="legal-index-icon" aria-hidden="true"><FileText size={18} /></span>
                <span className="legal-index-copy"><strong>{entry.title}</strong><small>{entry.summary}</small></span>
                {entry.where === "website" ? <ArrowUpRight size={16} aria-hidden="true" /> : <ChevronRight size={16} aria-hidden="true" />}
              </>
            );
            return (
              <li key={entry.id}>
                {entry.where === "website"
                  ? <a href={`${WEBSITE_URL}${entry.path}`} target="_blank" rel="noreferrer" className="legal-index-row">{body}</a>
                  : <Link to={entry.path} className="legal-index-row">{body}</Link>}
              </li>
            );
          })}
        </ul>

        <h2>Avisos de los servicios</h2>
        <details className="legal-notice-block">
          <summary>Wallet y Apartados · Kuspit Casa de Bolsa</summary>
          <p>{KUSPIT_WALLET_NOTICE}</p>
          {KUSPIT_LEGAL_NOTICE.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </details>
        <details className="legal-notice-block">
          <summary>Viaja ahora, paga después · Peso a Peso</summary>
          {[...PESO_A_PESO_NOTICE.summary, ...PESO_A_PESO_NOTICE.more].map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </details>
        <details className="legal-notice-block">
          <summary>Viajes · Aventuria, agencia de viajes</summary>
          <p>{TRAVEL_AGENCY_NOTICE}</p>
        </details>
      </main>
    </div>
  );
}

/** Política de Cookies, listed in Información legal (also on www). */
export function CookiePolicyPage() {
  return <LegalDocumentPage eyebrow="Política de cookies" document={COOKIE_POLICY} />;
}
